import styled, { css } from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { SVGIconCustomWrapperStyled } from '@yme/atoms/button/styled';
import { colorBrandYamahaRed } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
export const ButtonsGroupWrapperStyled = styled.div `
  margin-top: 24px;
`;
export const ButtonSelectorContainerStyled = styled(FlexWrapper) ``;
export const ButtonsGroupInnerStyled = styled(FlexWrapper) `
  width: 100%;

  gap: ${({ getter }) => `${getter}px`};

  & > * {
    ${({ count, isMobileView }) => count === 2 && !isMobileView && 'flex: 1'}
  }
  & > button,
  & > ${ButtonSelectorContainerStyled} {
    ${({ isButtonInline, count, getter }) => {
    if (count === 1) {
        return 'width: 100%';
    }
    return isButtonInline
        ? css `
            width: calc((100% / ${count}) - ((${count} - 1) * (${getter}px / ${count})));
          `
        : 'width: 100%';
}}
  }

  & > .favorite-button {
    svg path {
      fill: white;
      transition: all 0.1s ease-in;
    }
    :hover {
      svg path {
        stroke: ${({ isMobileView }) => (isMobileView ? colorBrandYamahaRed : 'black')};
        fill: ${colorBrandYamahaRed};
      }
    }

    ${({ isMobileView }) => !isMobileView
    ? `
  width: 52px;
  margin-left: 12px;
  height: 48px;
  border-radius: 50%;
  `
    : `
    margin-top: 16px;
  `}

    &.favorite-button--active {
      svg path {
        fill: ${colorBrandYamahaRed};
        stroke: ${colorBrandYamahaRed};
      }
      :hover {
        svg path {
          stroke: ${({ isMobileView }) => (isMobileView ? 'black' : 'white')};
          fill: ${({ isMobileView }) => (isMobileView ? 'transparent' : 'black')};
        }
      }
    }
  }

  ${ADAPTIVE.maxWidth.mobile} {
    & > button {
      width: 100%;
      flex-basis: 100%;
    }
  }
`;
export const QuantitySelectorWrapperStyled = styled.div `
  width: 78px;
  flex: 1 0 auto;
`;
export const ButtonStyled = styled(Button) `
  ${SVGIconCustomWrapperStyled} {
    svg {
      ${({ isRightToLeft }) => isRightToLeft && 'transform: rotateY(180deg);'};
    }
  }
`;
